// TODO: 6월 21일 라이브버전 주석처리
export type SubMenuItem = {
  name: string
  path: string
}

export type MenuItem = {
  id: number
  title: string
  path: string
  color: string
  display: boolean
  subItems?: SubMenuItem[]
}

export const menuItems = [
  {
    id: 1,
    title: '행사 정보',
    path: '/event-info/introduction',
    color: 'white',
    display: true,
    subItems: [
      {
        name: '행사 소개',
        path: '/event-info/introduction',
      },
      {
        name: '행사 시간표',
        path: '/event-info/timetable',
      },
      {
        name: '행사 배치도',
        path: '/event-info/layout',
      },
      {
        name: '참여 서클 리스트',
        path: '/event-info/circle-list',
      },
    ],
  },
  {
    id: 2,
    title: '특별 공연',
    path: '/sif-rainbowstage1',
    color: 'white',
    display: true,
    subItems: [
      {
        name: 'SIF Rainbow Stage',
        path: '/sif-rainbowstage1',
      },
    ],
  },
  {
    id: 3,
    title: '일반 참가',
    path: '/general-participation/info',
    color: 'white',
    display: true,
    subItems: [
      {
        name: '일반 참가 안내',
        path: '/general-participation/info',
      },
      {
        name: '코스프레 참가 안내',
        path: '/general-participation/cosplayer',
      },
      { name: '티켓 구매', path: '/general-participation/ticket' },
    ],
  },
  {
    id: 4,
    title: '서클 부스 참가',
    path: '/circle-participation/info',
    color: 'white',
    display: true,
    subItems: [
      {
        name: '서클 참가 안내',
        path: '/circle-participation/info',
      },
      {
        name: '서클 참가 신청',
        path: '/circle-participation/apply',
      },
      {
        name: '서클 신청 내역',
        path: '/circle-participation/apply-list',
      },
    ],
  },
  {
    id: 5,
    title: '기업 참가',
    path: '/corporate-participation/info',
    color: 'white',
    display: true,
    subItems: [
      { name: '기업 참가 안내', path: '/corporate-participation/info' },
      // { name: '기업 1:1 문의', path: '/corporate-participation/inquiry' },
    ],
  },
  {
    id: 6,
    title: '공지사항',
    path: '/notice',
    color: 'white',
    display: true,
    subItems: [{ name: '공지사항', path: '/notice' }],
  },
  {
    id: 7,
    title: '문의하기',
    path: '/customer-service/faq',
    color: 'white',
    display: true,
    subItems: [
      { name: 'FAQ', path: '/customer-service/faq' },
      { name: '1:1 문의', path: '/customer-service/inquiry' },
    ],
  },

  {
    id: 8,
    title: '홈',
    path: '/',
    color: '#111827',
    display: false,
    subItems: [],
  },
  {
    id: 9,
    title: '내정보',
    path: '/mypage',
    color: '#111827',
    display: false,
    subItems: [],
  },
  {
    id: 10,
    title: '정보수정',
    path: '/mypage/edit',
    color: '#111827',
    display: false,
    subItems: [],
  },
]

export const displayMenuItems: MenuItem[] = menuItems.filter(
  (item) => item.display,
)
